<template>
  <div
    class="dashboard-certificate-overview-card border-dashboard-bottom py-6"
    :class="$vuetify.display.smAndDown ? 'd-block' : ''"
  >
    <div class="align-center" style="display: flex">
      <div class="certificate-image-wrapper mr-2">
        <img :src="certificateImageSrc" alt="Certificate icon" class="certificate-image" />
      </div>
      <div class="ml-1 text-body-2">
        <p class="mb-0 font-weight-bold text-accelerate-grey-1">{{ certificateTitle }}</p>
        <p class="mb-0 text-accelerate-grey-2">
          {{ certificateCreditsCompleted }}/{{ certificateTotalCredits }} credits
        </p>
      </div>
    </div>
    <div
      class=""
      :class="
        $vuetify.display.smAndDown
          ? 'dashboard-certificate-overview-mobile mt-6'
          : 'dashboard-certificate-overview-desktop'
      "
      :style="$vuetify.display.smAndDown ? 'align-items:center' : ''"
    >
      <!-- TODO: When new updated link is available -->
      <button v-if="false" :class="$vuetify.display.smAndDown ? '' : 'mr-6'">
        <a
          :href="certificateUrl"
          target="_blank"
          class="degrees-certificates-view-more text-caption"
          style="color: #8c1d40; text-decoration: underline"
          >View more</a
        >
      </button>

      <!--  TODO : Update the button based on the status -->

      <button
        v-show="$vuetify.display.smAndDown ? buttonText : true"
        class="px-4 py-2 font-weight-bold btn-rounded-pill text-caption fixed-width-button"
        disabled
        :class="[buttonClass, { 'mr-6': $vuetify.display.smAndDown }]"
        @click="handleCertificatesModalCta()"
      >
        <v-icon v-if="certificateStatus === 'completed'">mdi-check</v-icon>
        <img v-if="certificateStatus === 'inprogress'" :src="greyInProgressCircleIcon" style="width: 16px" />
        {{ buttonText }}
      </button>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import greyInProgressCircleIcon from '@/assets/icons/grey-in-progress-circle-icon.svg';

export default defineComponent({
  emits: ['handleCertificatesModalCta', 'certificatesSeeDetailsCta'],

  data() {
    return {
      greyInProgressCircleIcon
    };
  },

  props: {
    image: {
      type: String,
      default: ''
    },
    certificateTitle: {
      type: String,
      default: ''
    },
    certificateStatus: {
      type: String,
      default: ''
    },
    certificateCreditsCompleted: {
      type: Number,
      default: 0
    },
    certificateTotalCredits: {
      type: Number,
      default: 0
    },
    certificateUrl: {
      type: String,
      default: ''
    }
  },

  computed: {
    certificateImageSrc() {
      // Use dynamic import for certificate images
      // Note: In Vite, dynamic imports require explicit path handling
      return new URL(`/src/assets/icons/accelerate-dashboard-certificates/${this.image}`, import.meta.url).href;
    },
    buttonText() {
      switch (this.certificateStatus) {
        // case 'open':
        //   return 'Add as Goal';
        case 'inprogress':
          return 'In-progress';
        case 'completed':
          return 'Completed';
        default:
          return '';
      }
    },
    buttonClass() {
      return this.certificateStatus === 'completed'
        ? 'certificate-btn-completed'
        : this.certificateStatus === 'inprogress'
          ? 'certificate-btn-inprogress'
          : '';
    },
    // buttonIcon() {
    //   return this.certificateStatus === 'completed' || this.certificateStatus === 'inprogress' ? 'fa-check' : 'fa-plus';
    // },
    isCompleted() {
      return this.certificateStatus === 'completed';
    }
  },

  methods: {
    handleCertificatesModalCta() {
      this.$emit('handleCertificatesModalCta');
    },
    certificatesSeeDetailsCta() {
      this.$emit('certificatesSeeDetailsCta');
    }
  }
});
</script>

<style lang="scss" scoped>
.dashboard-certificate-overview-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.dashboard-certificate-overview-mobile {
  display: flex;
  flex-direction: row-reverse;
  align-items: flex-start;
  justify-content: flex-end;
}
.dashboard-certificate-overview-desktop {
  display: flex;
}
.border-dashboard-bottom {
  border-bottom: 1px solid #d0d0d0;
}
.btn-rounded-pill {
  border-radius: 9999px;
}
.certificate-btn-completed {
  background-color: #498500;
  color: #ffffff;
  border: 1px solid #498500;
  opacity: 0.55;
  // cursor: not-allowed;
}

.certificate-btn-inprogress {
  background-color: #fff;
  color: #747474;
  border: 1px solid #000;
}

.certificate-btn-open {
  background-color: #191919;
  color: white;
  border: 1px solid #000;
}
.degrees-certificates-view-more {
  color: #8c1d40;
  // font-size: 12px;
  text-decoration-line: underline;
}
.fixed-width-button {
  min-width: 120px;
  text-align: center;
  visibility: visible;
}

.certificate-image-wrapper {
  width: 32px;
  height: 32px;
  background-color: #e2e2e2;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.certificate-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
</style>
